import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children, requiredRole }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    // Ask the backend “/verify” to see if our cookie is still valid
    fetch('/api/verify', { credentials: 'include' })
      .then(res => {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(data => {
        setIsAuthenticated(true);
        setUserRole(data.role);
      })
      .catch(() => {
        setIsAuthenticated(false);
      });
  }, []);

  if (isAuthenticated === null) return <p>Loading...</p>;

  if (!isAuthenticated) return <Navigate to="/" />; 

  if (requiredRole) {
    const allowed = Array.isArray(requiredRole)
      ? requiredRole
      : [requiredRole];
    if (!allowed.includes(userRole)) {
      return <p>Access denied: you do not have permission</p>;
    }
  }

  return children;
}
